module.exports = __webpack_public_path__ + "img/bg.10d45be1.jpg";